module.exports = __webpack_public_path__ + "img/img_t6@2x.1d7df5c1.png";